import { cva, VariantProps } from 'class-variance-authority';
import { HTMLAttributes, useState } from 'react';

import { cn } from './cn';

const avatarVariants = cva(
  'relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-brand-subtle font-medium text-brand',
  {
    variants: {
      size: {
        small: 'size-6 text-caption',
        medium: 'size-8 text-xs',
        large: 'size-10 text-sm',
      },
    },
    defaultVariants: {
      size: 'medium',
    },
  },
);

export interface AvatarProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof avatarVariants> {
  alt?: string;
  src?: string | null;
}

export const Avatar = ({ alt = '', children, className, size, src, ...props }: AvatarProps) => {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const showImage = !!src && failedSrc !== src;
  const pixels = size === 'small' ? 24 : size === 'large' ? 40 : 32;
  return (
    <span className={cn(avatarVariants({ className, size }))} {...props}>
      {showImage ? (
        <img
          alt={alt}
          src={src}
          width={pixels}
          height={pixels}
          className="size-full object-cover"
          onError={() => setFailedSrc(src)}
        />
      ) : (
        children
      )}
    </span>
  );
};
